export const OrderBySortOrder = {
  ascend: 'ASC',
  descend: 'DESC',
};
